import videojs from 'video.js';
const Component = videojs.getComponent('Component');

const DEFAULTS = {
    popupShowTime: 3000
};

/**
 * The button component for showing WebSockets messages popup
 *
 * @param {Object} player   Main Player
 * @param {Object=} options Object of option names and values
 * @extends Button
 */
class WSMessagesPopup extends Component {
  constructor(player, options) {
    let options_ = Object.assign({}, DEFAULTS, options); 
    super(player, options_);
    this.popupShowTime = options_.popupShowTime;
    this.hide();
  }

  buildCSSClass() {
    return `vjs-ws-messages-popup ${super.buildCSSClass()}`;
  }

  createEl() {
    return super.createEl('div', {
      className: this.buildCSSClass()
    });
  }

  show(txt, val, options = {}) {
    this.clearStyles();
    if (typeof val == 'object') {
      this.showObject(val);
    } else {
      this.showTextMsg(txt, val);
    }
    super.show();
    this.align();

    if (options.position) {
      this.setPosition(options.position);
    }

    let hideTime = val && val.ttl || this.popupShowTime;
    this.player_.setTimeout(() => {
      this.hide();
    }, hideTime);
  }

  showObject(obj) {
    this.el().innerHTML = obj.msg;
    if (obj.position) {
      this.el().style.top = obj.position.top;
      this.el().style.left = obj.position.left;
    }
    if (obj.style) {
      this.el().classList.add(obj.style);
    }
  }

  align() {
    let elRect = this.el().getBoundingClientRect();
    let parentRect = this.el().parentElement.getBoundingClientRect();

    let elRectWidthBound = elRect.left + elRect.width;
    let parentRectWidthBound = parentRect.left + parentRect.width;
    if (elRectWidthBound >= parentRectWidthBound) {
      this.el().style.left = `${parentRect.width - elRect.width}px`;
    }

    let elRectHeightBound = elRect.top + elRect.height;
    let parentRectHeightBound = parentRect.top + parentRect.height;
    if (elRectHeightBound >= parentRectHeightBound) {
      this.el().style.top = `${parentRect.height - elRect.height}px`;
    }
  }

  showTextMsg(txt, val) {
    this.el().innerHTML = txt + (txt ? ': ' : '') + val;
  }

  /**
   * Set popup position in player
   *
   * @param {String} position
   */
  setPosition(position) {
    if (position.match(/top/)) {
      let topPanelEl = this.player_.getChild('TopPanel').el();
      let topVal = Math.ceil(topPanelEl.getBoundingClientRect().height);
      this.el().style.top = `${topVal}px`;
    }
    if (position.match(/bottom/)) {
      let controlBarEl = this.player_.getChild('controlBar').el();
      let bottomVal = Math.ceil(controlBarEl.getBoundingClientRect().height);
      this.el().style.bottom = `${bottomVal}px`;
    }
    if (position.match(/right/)) {
      this.el().style.right = '0px';
    }
    if (position.match(/left/)) {
      this.el().style.left = '0px';
    }
    if (position.match(/center/)) {
      this.el().style.top = '50%';
      this.el().style.left = '50%';
      this.el().style.transform = 'translate(-50%, -50%)';
    }
  }

  /**
   * Clear popup styles
   */
  clearStyles() {
    this.el().style.removeProperty('top');
    this.el().style.removeProperty('bottom');
    this.el().style.removeProperty('right');
    this.el().style.removeProperty('left');
    this.el().style.removeProperty('transform');
  }
}
Component.registerComponent('WSMessagesPopup', WSMessagesPopup);
export default WSMessagesPopup;
